export const ICONS = {
    Cancel: (
        <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" />
    ),
    Check: <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />,
    CheckCircle: (
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
    ),
    ChevronLeft: (
        <>
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
        </>
    ),
    ChevronRight: <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />,
    Download: (
        <g>
            <path d="M5,20h14v-2H5V20z M19,9h-4V3H9v6H5l7,7L19,9z" />
        </g>
    ),
    List: (
        <>
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z" />
        </>
    ),
    Upload: <path d="M5,20h14v-2H5V20z M5,10h4v6h6v-6h4l-7-7L5,10z" />,
    ViewAgenda: (
        <>
            <g>
                <rect fill="none" height="24" width="24" x="0" y="0" />
            </g>
            <g>
                <g>
                    <path d="M19,13H5c-1.1,0-2,0.9-2,2v4c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4C21,13.9,20.1,13,19,13z" />
                    <path d="M19,3H5C3.9,3,3,3.9,3,5v4c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3z" />
                </g>
            </g>
        </>
    ),
    Warning: (
        <>
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
        </>
    ),
    ExpandMore: (
        <>
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" />
        </>
    ),
    ExpandLess: (
        <>
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z" />
        </>
    ),
    ArrowRightAlt: (
        <path d="M13.2254 17.2954C13.0371 17.1072 12.9469 16.8798 12.9548 16.6131C12.9626 16.3464 13.0606 16.119 13.2489 15.9306L15.9077 13.2719H5.41359C5.14693 13.2719 4.92339 13.1817 4.743 13.0013C4.56261 12.8209 4.47241 12.5974 4.47241 12.3307C4.47241 12.064 4.56261 11.8405 4.743 11.6601C4.92339 11.4797 5.14693 11.3895 5.41359 11.3895H15.9077L13.2254 8.70717C13.0371 8.51893 12.943 8.29541 12.943 8.03659C12.943 7.77775 13.0371 7.55423 13.2254 7.366C13.4136 7.17775 13.6371 7.08364 13.8959 7.08364C14.1548 7.08364 14.3782 7.17775 14.5666 7.366L18.8725 11.6719C18.9665 11.766 19.0333 11.868 19.0724 11.9778C19.1116 12.0876 19.1312 12.2052 19.1312 12.3307C19.1312 12.4562 19.1116 12.5738 19.0724 12.6836C19.0333 12.7934 18.9665 12.8954 18.8725 12.9895L14.543 17.319C14.3705 17.4915 14.1548 17.5777 13.8959 17.5777C13.6371 17.5777 13.4136 17.4836 13.2254 17.2954Z" />
    ),
    ArrowLeftAlt: (
        <path d="M8.09447 13.2716L10.7768 15.9539C10.9651 16.1423 11.0553 16.3618 11.0474 16.6128C11.0396 16.8638 10.9494 17.0833 10.7768 17.2717C10.5886 17.4599 10.3651 17.5578 10.1062 17.5657C9.84742 17.5735 9.62389 17.4834 9.43565 17.2951L5.12977 12.9893C4.94153 12.801 4.84741 12.5814 4.84741 12.3304C4.84741 12.0795 4.94153 11.8598 5.12977 11.6716L9.43565 7.36573C9.62389 7.1775 9.84742 7.0873 10.1062 7.09514C10.3651 7.10298 10.5886 7.20102 10.7768 7.38926C10.9494 7.57749 11.0396 7.79711 11.0474 8.04808C11.0553 8.29906 10.9651 8.51867 10.7768 8.7069L8.09447 11.3893H18.5886C18.8552 11.3893 19.0787 11.4795 19.2591 11.6599C19.4396 11.8402 19.5298 12.0638 19.5298 12.3304C19.5298 12.5971 19.4396 12.8206 19.2591 13.001C19.0787 13.1814 18.8552 13.2716 18.5886 13.2716H8.09447Z" />
    ),
    Close: (
        <>
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
        </>
    ),
    Add: (
        <>
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
        </>
    ),
    HelpOutline: (
        <>
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z" />
        </>
    ),
    CalendarMonth: (
        <g>
            <path d="M19,4h-1V2h-2v2H8V2H6v2H5C3.89,4,3.01,4.9,3.01,6L3,20c0,1.1,0.89,2,2,2h14c1.1,0,2-0.9,2-2V6C21,4.9,20.1,4,19,4z M19,20 H5V10h14V20z M9,14H7v-2h2V14z M13,14h-2v-2h2V14z M17,14h-2v-2h2V14z M9,18H7v-2h2V18z M13,18h-2v-2h2V18z M17,18h-2v-2h2V18z" />
        </g>
    ),
    ErrorOutline: (
        <>
            <path d="M0 0h24v24H0V0z" fill="none" />
            <path d="M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
        </>
    ),
    Error: (
        <>
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
        </>
    ),
    Info: (
        <>
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
        </>
    ),
    Mail: (
        <>
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
        </>
    ),
    Call: (
        <>
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z" />
        </>
    ),
    ModeComment: (
        <>
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18z" />
        </>
    ),
    Pending: (
        <>
            <g>
                <rect fill="none" height="24" width="24" />
            </g>
            <g>
                <path d="M12,2C6.48,2,2,6.48,2,12c0,5.52,4.48,10,10,10s10-4.48,10-10C22,6.48,17.52,2,12,2z M7,13.5c-0.83,0-1.5-0.67-1.5-1.5 c0-0.83,0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5C8.5,12.83,7.83,13.5,7,13.5z M12,13.5c-0.83,0-1.5-0.67-1.5-1.5 c0-0.83,0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5C13.5,12.83,12.83,13.5,12,13.5z M17,13.5c-0.83,0-1.5-0.67-1.5-1.5 c0-0.83,0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5C18.5,12.83,17.83,13.5,17,13.5z" />
            </g>
        </>
    ),
    Menu: (
        <>
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
        </>
    ),
    Delete: (
        <>
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
        </>
    ),
    FilterList: (
        <>
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" />
        </>
    ),
    Visibility: (
        <>
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
        </>
    ),
    Lock: (
        <>
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" />
        </>
    ),
    Send: (
        <>
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
        </>
    ),
    SubdirectoryArrowRight: (
        <>
            <path d="M0 0h24v24H0V0z" fill="none" />
            <path d="M19 15l-6 6-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9l6 6z" />
        </>
    ),
    CircleFilled: (
        <>
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2z" />
        </>
    ),
    Placeholder: (
        <path
            d="M11.373 21.8557C10.3025 21.6519 9.24933 21.3041 8.21345 20.8125C7.17755 20.3208 6.25287 19.6368 5.43942
               18.7605C4.62596 17.8843 3.96794 16.8022 3.46537 15.5144C2.96282 14.2266 2.71155 12.6898 2.71155 10.9039V10.7231C2.71155
               10.5154 2.77693 10.3462 2.9077 10.2154C3.03846 10.0847 3.20769 10.0193 3.41537 10.0193H3.57692C4.34999 10.0193 5.20095
               10.1565 6.1298 10.4308C7.05865 10.7052 7.88589 11.0718 8.61152 11.5308C8.74357 10.3552 9.05254 9.13821 9.53842
               7.87987C10.0243 6.62154 10.625 5.48982 11.3403 4.4847C11.5147 4.23982 11.7346 4.11737 11.9999 4.11737C12.2653 4.11737
               12.4852 4.23982 12.6595 4.4847C13.3749 5.48982 13.9756 6.62475 14.4615 7.8895C14.9474 9.15423 15.2563 10.3744 15.3884
               11.55C16.0948 11.1103 16.906 10.7501 17.822 10.4693C18.7381 10.1885 19.5986 10.0385 20.4037 10.0193L20.5422 10.0096C20.7538
               10.0032 20.9342 10.0747 21.0835 10.2241C21.2329 10.3734 21.3044 10.5539 21.298 10.7654L21.2883 10.9231C21.2435 12.5423
               21.0034 13.9654 20.5682 15.1923C20.1329 16.4192 19.547 17.474 18.8105 18.3567C18.074 19.2394 17.207 19.9602 16.2096
               20.5192C15.2121 21.0782 14.1269 21.5077 12.9538 21.8076C12.7371 21.8602 12.4737 21.8897 12.1634 21.8961C11.8532 21.9025
               11.5897 21.8891 11.373 21.8557ZM12.1423 20.45C11.9589 17.7 11.1298 15.6125 9.65477 14.1875C8.17977 12.7625 6.37561 11.8833
               4.24227 11.55C4.20894 11.55 4.20894 11.55 4.24227 11.55C4.42561 14.3667 5.27977 16.4833 6.80477 17.9C8.32977 19.3167 10.1089
               20.1667 12.1423 20.45C12.1756 20.4667 12.1756 20.4708 12.1423 20.4625C12.1089 20.4542 12.1089 20.45 12.1423 20.45ZM10.0499
               12.45C10.4025 12.7462 10.7573 13.1061 11.1144 13.5298C11.4714 13.9536 11.7666 14.3616 11.9999 14.7539C12.2371 14.3616
               12.5333 13.9536 12.8884 13.5298C13.2435 13.1061 13.5974 12.7462 13.9499 12.45C13.9294 11.468 13.7483 10.4378 13.4067
               9.35965C13.065 8.28143 12.5961 7.24104 11.9999 6.23847C11.4038 7.24104 10.9349 8.27982 10.5932 9.35482C10.2516 10.4298
               10.0705 11.4616 10.0499 12.45ZM12.8115 16.3923C13.0115 16.9257 13.1791 17.4865 13.3143 18.075C13.4496 18.6635 13.5589
               19.3244 13.6422 20.0577C14.3256 19.8256 15.0134 19.4984 15.7057 19.0759C16.398 18.6535 17.0259 18.1042 17.5894
               17.4279C18.1528 16.7516 18.6333 15.9324 19.0307 14.9702C19.4281 14.008 19.6704 12.8679 19.7576 11.55C19.7576 11.5167
               19.7576 11.5167 19.7576 11.55C18.1653 11.7833 16.7583 12.3282 15.5365 13.1846C14.3147 14.041 13.4063 15.1103 12.8115 16.3923Z"
        />
    ),
    Person: (
        <>
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
        </>
    ),
}
